export type ProgressPhase = 'thinking' | 'searching' | 'working' | 'composing' | 'presenting';
export const progressLabels: Record<ProgressPhase, string> = {
  thinking: 'Thinking through your request',
  searching: 'Searching available sources',
  working: 'Checking the information for your request',
  composing: 'Writing your answer',
  presenting: 'Preparing your response',
};
export function readResponseProgress(event: string, data: string): { phase: ProgressPhase; deferred: boolean; label?: string } | null {
  if (event === 'response-progress') {
    try {
      const value = JSON.parse(data);
      if (value.version === 1 && Object.prototype.hasOwnProperty.call(progressLabels, value.phase)
          && ['deferred', 'streaming'].includes(value.presentation)) {
        return { phase: value.phase, deferred: value.presentation === 'deferred',
          ...(typeof value.label === 'string' && value.label.length <= 200 && value.label.trim() ? { label: value.label } : {}) };
      }
    } catch { /* Unsupported progress never interrupts the actual answer. */ }
    return null;
  }
  // Compatibility with providers that still emit the original status events.
  if (event !== 'status-update') return null;
  if (data === 'Planning') return { phase: 'thinking', deferred: false };
  if (data.startsWith('Searching')) return { phase: 'searching', deferred: true };
  if (/^Running .+ tool$/.test(data)) return { phase: 'working', deferred: true };
  return null;
}
